const SHORT_DATE = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const DAY_MONTH = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
});

const ISO_DATE = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const SHORT_DATE_TIME = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const TIME = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
});

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const WEEKDAY_DATE = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const WEEKDAY = new Intl.DateTimeFormat('en-US', { weekday: 'long' });

const LONG_DATE = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

const toLocalDate = (value: string): Date => {
  if (DATE_ONLY.test(value)) {
    return new Date(`${value}T00:00:00`);
  }

  return new Date(value);
};

const toShortDate = (value: string): string => SHORT_DATE.format(new Date(value));

const toShortDateTime = (value: string): string => SHORT_DATE_TIME.format(new Date(value));

const toWeekdayDate = (value: string): string => WEEKDAY_DATE.format(toLocalDate(value));

const toWeekday = (value: string): string => WEEKDAY.format(toLocalDate(value));

const toAge = (value: string | null): string => {
  if (!value) {
    return '';
  }

  const birth = toLocalDate(value);
  const now = new Date();
  const years = now.getFullYear() - birth.getFullYear();
  const hasHadBirthday = now.getMonth() > birth.getMonth()
    || (now.getMonth() === birth.getMonth() && now.getDate() >= birth.getDate());

  return String(hasHadBirthday ? years : years - 1);
};

const toDayMonth = (value: string): string => DAY_MONTH.format(new Date(value));

const toDayMonthTime = (value: string): string => `${DAY_MONTH.format(new Date(value))} · ${TIME.format(new Date(value))}`;

const toISODate = (value: string): string => ISO_DATE.format(new Date(value));

const toLongDate = (value: Date): string => LONG_DATE.format(value);

export {
  toAge,
  toDayMonth,
  toDayMonthTime,
  toISODate,
  toLocalDate,
  toLongDate,
  toShortDate,
  toShortDateTime,
  toWeekday,
  toWeekdayDate,
};
